/**
 * Helper component that lets you build a simple array of strings
 *
 * NOTE: For an example, see the roles builder in
 * ./modules/user/AdminUserForm.js.jsx
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

// import componets
import Base from "../BaseComponent.js.jsx";
import TextInput from './TextInput.js.jsx';

// import global components
import AlertModal from "../../../global/components/modals/AlertModal.js.jsx";

class SimpleArrayEditor extends Base {
  constructor(props) {
    super(props);
    this.state = {
      confirmRemoveItemModalOpen: false
      , indexToRemove: null
      , newItem: ''
      , removingItem: false
    }
    this._bind(
      '_handleNewItemChange'
      , '_addPillItem'
      , '_removePillItem'
    );

  }

  // check against any new props the component receives
  componentWillReceiveProps(nextProps) {
    if(this.props.arrayType != nextProps.arrayType) {
      if(nextProps.arrayType == "string") {
        this.setState({newItem: ''});
      } else {
        this.setState({newItem: 0});
      }
    }
  }

  _removePillItem(index) {
    this.setState({removingItem: true})
    if(!index) {
      index = this.state.indexToRemove;
    }
    let items = this.props.items;
    items.splice(index, 1);
    let event = {target: {name: this.props.name, value: this.props.items} };
    this.props.change(event);
    this.setState({
      confirmRemoveItemModalOpen: false
      , indexToRemove: null
      , removingItem: false
    })
  }

  _addPillItem(value) {
    let newState = this.state;
    if(this.props.arrayType == "string") {
      newState.newItem = "";
    } else {
      newState.newItem = 0;
      value = parseFloat(value);
    }
    let items = this.props.items;
    items.push(value);
    let event = {target: {name: this.props.name, value: this.props.items} };
    this.props.change(event);
    this.setState(newState);
  }

  _handleNewItemChange(e) {
    this.setState({newItem: e.target.value});
  }

  _openConfirmRemoveItemModal(index) {
    this.setState({
      confirmRemoveItemModalOpen: true
      , indexToRemove: index
    })
  }
  render() {
    const {
      confirmDelete
      , items
      , name
      , label
      , arrayType
      , helpText
    } = this.props;

    // build the pill items from the newly edited array
    let pillItems = confirmDelete ?
      items.map((item, index) => {
        return (
          <div className="pill-item" key={index}>
            <p>
              <a>
                <i className="-icon fas fa-times" onClick={() => this._openConfirmRemoveItemModal(index)}></i>
                {item}
              </a>
            </p>
          </div>
        )
      })
    :
      items.map((item, index) => {
        return (
          <div className="pill-item" key={index}>
            <p>
              <a>
                <i className="-icon fas fa-times" onClick={() => this._removePillItem(index)}></i>
                {item}
              </a>
            </p>
          </div>
        )
      });

    let theInput;
    if(arrayType === "string") {
      theInput = (
        <input
          type="text"
          name="newItem"
          placeholder={`New ${label}` }
          value={this.state.newItem}
          onChange={this._handleNewItemChange}
        />
      );
    } else {
      theInput = (
        <input
          type="number"
          name="newItem"
          value={this.state.newItem}
          onChange={this._handleNewItemChange}
        />
      )
    }

    return (
      <div className="input-group">
        <label htmlFor="newItem"> { label } </label>
        <div className="pills">
          {pillItems}
        </div>
        <div className="input-add-on">
          {theInput}
          <button
            className="item"
            type="button"
            onClick={() => this._addPillItem(this.state.newItem)}
            disabled={this.state.newItem  ? false : true }
          > Add {label}</button>
        </div>
        <small className="help-text"><em>{helpText}</em></small>
        <AlertModal
          alertMessage={<div><strong>CAUTION: </strong> Are you <em>sure</em> you want to delete this item?</div>}
          alertTitle="Confirm delete item"
          closeAction={() => this.setState({confirmRemoveItemModalOpen: false, indexToRemove: null})}
          declineText="Nevermind"
          disabled={this.state.removingItem}
          confirmAction={this._removePillItem}
          confirmText={this.state.removingItem ? "Deleting..." : "Yes, delete it."}
          isOpen={this.state.confirmRemoveItemModalOpen}
          preventFormSubmit={true}
          type="danger"
        />
      </div>
    )
  }
}

SimpleArrayEditor.propTypes = {
  arrayType: PropTypes.oneOf(["string", "number"])
  , change: PropTypes.func.isRequired
  , confirmDelete: PropTypes.bool
  , helpText: PropTypes.any
  , items: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.string)
      , PropTypes.arrayOf(PropTypes.number)
    ])
  , label: PropTypes.string
  , name: PropTypes.string.isRequired
}

SimpleArrayEditor.defaultProps = {
  arrayType: "string"
  , helpText: null
  , items: []
  , label: ''
}

export default SimpleArrayEditor;



// WEBPACK FOOTER //
// global/components/forms/SimpleArrayEditor.js.jsx